import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { deviceBreakpoints } from '../../hooks/useDeviceQuery.hook';
import { BoldPlugin } from '../../slatePlugins/marks/bold/BoldPlugin';
import { HighlightPlugin } from '../../slatePlugins/marks/highlight/HighlightPlugin';
import { ItalicPlugin } from '../../slatePlugins/marks/italic/ItalicPlugin';
import { UnderlinePlugin } from '../../slatePlugins/marks/underline/UnderlinePlugin';
import { colorsV2 } from '../colors-v2';
import { Typography } from '../DesignSystemV2/Typography';
import { DolEditor } from '../DolEditor/DolEditor';
import { ReadOnlyPlugin } from '../DolEditor/handlers/read-only/ReadOnlyPlugin';

const Main = styled.section`
  margin-bottom: 12px;

  .guideline-content {
    background-color: ${colorsV2.white100};
    padding: 12px 16px;
  }

  .expand-collapse-header {
    color: ${colorsV2.white80};
    background-color: ${colorsV2.primary100};
    padding: 12px 16px;
    display: grid;
    grid-template-columns: 1fr max-content;
    cursor: pointer;

    .expand-collapse-arrow {
      display: grid;
      height: 20px;
      margin-top: 4px;
      font-size: 20px;
      line-height: 0;
      transition: all 0.4s ease;
    }
  }

  .expand-collapse-content {
    > * {
      padding: 12px 16px;
    }

    background-color: ${colorsV2.black10};
  }

  .guideline-header-content {
    pointer-events: none;
    overflow: hidden;
  }

  .guideline-header {
    display: grid;
    grid-auto-flow: row;
    align-items: center;
    gap: 4px;

    &-title {
      color: ${colorsV2.white100};
    }

    @media ${deviceBreakpoints.fromDesktop} {
      grid-auto-flow: column;
      gap: 16px;
      grid-template-columns: max-content;
    }
  }

  &.expanded {
    .expand-collapse-arrow {
      transform: rotate(180deg);
    }
  }

  @media ${deviceBreakpoints.fromTablet} {
    margin-bottom: 24px;
    border-radius: 12px;
    overflow: hidden;
  }
`;

export interface QuestionGroupGuidelineProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  content?: any;
  compactContent?: any;
  compactEnable?: boolean;
  initialExpandValue?: boolean;
}

const plugins = [
  ReadOnlyPlugin(),
  BoldPlugin(),
  ItalicPlugin(),
  UnderlinePlugin(),
  HighlightPlugin(),
];

export const QuestionGroupGuidelineV2 = (props: QuestionGroupGuidelineProps) => {
  const {
    className,
    title,
    compactContent,
    compactEnable,
    initialExpandValue = false,
    content,
  } = props;
  const haveCompact = Boolean(compactContent && compactEnable);
  return (
    <Main className={cl(className, { expanded: initialExpandValue })}>
      <div aria-hidden className="expand-collapse-header">
        <div className="guideline-header">
          <Typography.Paragraph className="guideline-header-title" variant="semi-bold/20">
            {title}
          </Typography.Paragraph>

          {haveCompact ? (
            <Typography.Paragraph className="guideline-header-content" variant="regular/14">
              <DolEditor
                editorClassName="online-test-question-guide-spacing"
                initialValue={compactContent}
                plugins={plugins}
              />
            </Typography.Paragraph>
          ) : (
            <Typography.Paragraph className="guideline-header-content" variant="regular/14">
              <DolEditor
                editorClassName="online-test-question-guide-spacing"
                initialValue={content}
                plugins={plugins}
              />
            </Typography.Paragraph>
          )}
        </div>
      </div>
    </Main>
  );
};
